// extracted by mini-css-extract-plugin
export default {"container":"comments-table_container__iKGls","header":"comments-table_header__ZZa9j"};